export const placingTypes = {
  ANY: 0,
  NOTINROUTE: 1,
  NOTINCAR: 2,
};
